import axios from 'axios';
import { Link } from 'react-router-dom';
import swal from 'sweetalert';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Topbar = () => {
    const navigate = useNavigate();

    // use state to track auth instead of checking localStorage directly
    const [isAuthenticated, setIsAuthenticated] = useState(
        !!localStorage.getItem('auth_token')
    );

    const logoutSubmit = (e) => {
        e.preventDefault();

        axios.post('/api/logout').then(res => {
            if (res.data.status === 200) {
                localStorage.removeItem('auth_token');
                localStorage.removeItem('auth_name');
                swal('Success', res.data.message, 'success');

                setIsAuthenticated(false);        
                navigate('/');
            }
            }).catch(error => {
                // 3. IMPROVEMENT: Handle server error/token expiry gracefully on client
                console.error("Logout failed on server:", error);
                localStorage.removeItem('auth_token');
                localStorage.removeItem('auth_name');
                setIsAuthenticated(false);
                swal('Success', 'Logged out successfully (Client clear)', 'success');
                navigate('/');
            });
    };

    useEffect(() => {
        setIsAuthenticated(!!localStorage.getItem('auth_token'));
    }, []);

  return (
    <div className="main-header">
        <div className="main-header-logo">
            <div className="logo-header" data-background-color="dark">
            <a href="" className="logo">
                <img
                src=""
                alt="navbar brand"
                className="navbar-brand"
                height="20"
                />
            </a>
            <div className="nav-toggle">
                <button className="btn btn-toggle toggle-sidebar">
                <i className="gg-menu-right"></i>
                </button>
                <button className="btn btn-toggle sidenav-toggler">
                <i className="gg-menu-left"></i>
                </button>
            </div>
            <button className="topbar-toggler more">
                <i className="gg-more-vertical-alt"></i>
            </button>
            </div>
        </div>
        <nav
            className="navbar navbar-header navbar-header-transparent navbar-expand-lg border-bottom"
        >
            <div className="container-fluid">
            <nav
                className="navbar navbar-header-left navbar-expand-lg navbar-form nav-search p-0 d-none d-lg-flex"
            >
            </nav>

            <ul className="navbar-nav topbar-nav ms-md-auto align-items-center">
                <li
                className="nav-item topbar-icon dropdown hidden-caret d-flex d-lg-none"
                >
                <a
                    className="nav-link dropdown-toggle"
                    data-bs-toggle="dropdown"
                    href="#"
                    role="button"
                    aria-expanded="false"
                    aria-haspopup="true"
                >
                    <i className="fa fa-search"></i>
                </a>
                <ul className="dropdown-menu dropdown-search animated fadeIn">
                    <form className="navbar-left navbar-form nav-search">
                    <div className="input-group">
                        <input
                        type="text"
                        placeholder="Search ..."
                        className="form-control"
                        />
                    </div>
                    </form>
                </ul>
                </li>
                
                <li className="nav-item topbar-icon dropdown hidden-caret">
                <a
                    className="nav-link dropdown-toggle"
                    href="#"
                    id="notifDropdown"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                >
                    <i className="fa fa-bell"></i>
                    <span className="notification">4</span>
                </a>
                <ul
                    className="dropdown-menu notif-box animated fadeIn"
                    aria-labelledby="notifDropdown"
                >                
                </ul>
                </li>

                <li className="nav-item topbar-user dropdown hidden-caret">
                <a
                    className="dropdown-toggle profile-pic"
                    data-bs-toggle="dropdown"
                    href="#"
                    aria-expanded="false"
                >
                    
                    <span className="profile-username">
                    <span className="op-7">Hi,</span>
                    {/* <span className="fw-bold">Hizrian</span> */}
                    </span>
                </a>

                <ul className="dropdown-menu dropdown-user animated fadeIn">
                    <div className="dropdown-user-scroll scrollbar-outer">
                    <li>
                        <div className="user-box">
                        {/* <div className="avatar-lg">
                            <img
                            src="assets/img/profile.jpg"
                            alt="image profile"
                            className="avatar-img rounded"
                            />
                        </div> */}
                        <div className="u-text">
                            <h4>Welcome</h4>
                            <p className="text-muted">admin@example.com</p>
                            <a
                            href="profile.html"
                            className="btn btn-xs btn-secondary btn-sm"
                            >View Profile</a
                            >
                        </div>
                        </div>
                    </li>
                    <li>
                        <div className="dropdown-divider"></div>
                        {/* <a className="dropdown-item" href="#">My Profile</a>
                        <a className="dropdown-item" href="#">My Balance</a>
                        <a className="dropdown-item" href="#">Inbox</a> */}
                        {/* <div className="dropdown-divider"></div> */}
                        <a className="dropdown-item" href="#">Account Setting</a>
                        {/* <div className="dropdown-divider"></div> */}
                        
                        <a className="dropdown-item" href="#">Logout</a>
                    </li>
                    </div>
                </ul>
                </li>

                {isAuthenticated ? (
                    <li className="nav-item">
                        <button 
                            type="button" 
                            onClick={logoutSubmit} 
                            className="btn nav-link text-white btn-danger" 
                            style={{ cursor: 'pointer' }} 
                        >
                            Logout ({localStorage.getItem('auth_name')})
                        </button>
                    </li>
                    ) : (
                    // Show Login and Register if not authenticated
                    <>
                    <li className="nav-item">
                        <Link to="/login" className="nav-link">Login</Link>
                    </li>
                    </>
                )}
            </ul>
            </div>
        </nav>
    </div> 
  )
}

export default Topbar
